import { useSearchParams } from 'react-router-dom';
import { ListingsQueryParams } from '../types/listings/listing.model';

export function useListingsParams(): [
  ListingsQueryParams,
  (
    params: Partial<ListingsQueryParams>,
    options?: { preservePage?: boolean },
  ) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const params: ListingsQueryParams = Object.fromEntries([...searchParams]);

  const updateParams = (
    newParams: Partial<ListingsQueryParams>,
    options?: { preservePage?: boolean },
  ) => {
    const updated = new URLSearchParams(searchParams);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        updated.delete(key);
      } else {
        updated.set(key, String(value));
      }
    });

    // Reset page unless preservePage is true
    if (!options?.preservePage) {
      updated.set('page', '1');
    }

    // Nothing changed → don't navigate. Re-writing the same URL (e.g. on
    // mount) used to add a history entry, reset scroll and pagination when
    // coming back from a listing.
    if (updated.toString() === searchParams.toString()) return;
    // Filters replace the entry (Back leaves the list instead of stepping
    // through every filter tweak); the list scrolls itself to the top.
    setSearchParams(updated, { replace: true, preventScrollReset: true });
  };

  return [params, updateParams];
}
